import React from 'react';
import styles from "../../../../styles/office/EditModal.module.css";

const AuthorizerConfirmationDialog = ({
  language,
  onCancel,
  onConfirm,
  isLoading = false // Add this prop
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.confirmationDialog}>
      <h3>{language === 'en' ? 'Confirm Changes' : 'बदलांची पुष्टी करा'}</h3>
      <p>{language === 'en'
        ? 'Are you sure you want to sign the document? ?'
        : 'तुम्हाला हे बदल जतन करायचे आहेत याची खात्री आहे?'}</p>
      
      {isLoading && (
        <div className={styles.dialogLoader}>
          <div className={styles.loadingSpinner}></div>
          <p>{language === 'en' ? 'Processing...' : 'प्रक्रिया करत आहे...'}</p>
        </div>
      )}
      
      <div className={styles.confirmationButtons}>
        <button
          onClick={onCancel}
          className={styles.cancelButton}
          disabled={isLoading}
        >
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button
          onClick={onConfirm}
          className={styles.saveButton}
          disabled={isLoading}
        >
          {isLoading ? (language === 'en' ? 'Processing...' : 'प्रक्रिया करत आहे...') : (language === 'en' ? 'Confirm' : 'पुष्टी करा')}
        </button>
      </div>
    </div>
  </div>
);

export default AuthorizerConfirmationDialog;